export default __webpack_public_path__ + "static/media/skyline_salzburg_blueish_02_basis.54aed8c4.svg";